import { render, staticRenderFns } from "./StepFB.vue?vue&type=template&id=69bace06&scoped=true&"
import script from "./StepFB.vue?vue&type=script&lang=js&"
export * from "./StepFB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bace06",
  null
  
)

export default component.exports